module.exports = __webpack_public_path__ + "static/media/icon_config_multimedia.820bca81.svg";